import { IUnitResponse } from '@kcftech/prometheustypescriptapiclient';
import { Dropdown } from 'components/dropdown/Dropdown';
import { useInfiniteUnitsDataSource } from 'custom_hooks/data_hooks/data_source/unitDataSource';
import { dropdownTriggerStyles } from 'pages/Settings/ThirdPartySensorModels/styled';
import { useEffect } from 'react';
import { useThemeValues } from 'styles/theme';

export type UnitsDropdownProps = Readonly<{
    value: IUnitResponse | undefined;
    onChange: (newValue: IUnitResponse | undefined) => void;
    physicalQuantityCode?: string;
    disabled?: boolean;
}>;

export function UnitsDropdown({
    value,
    onChange,
    physicalQuantityCode,
    disabled,
}: UnitsDropdownProps) {
    const { shadeBackgroundColor, borderColor } = useThemeValues();

    const {
        results,
        hasNext,
        loadNext,
        isLoading,
        filter,
        setFilter,
    } = useInfiniteUnitsDataSource({
        name: 'units-dropdown',
        defaultFilter: {
            physicalQuantityCode,
        },
        enabled: !disabled,
    });

    useEffect(() => {
        setFilter((currentFilter) => ({ ...currentFilter, physicalQuantityCode }));
    }, [setFilter, physicalQuantityCode]);

    return (
        <Dropdown<IUnitResponse>
            trigger={{
                style: {
                    ...dropdownTriggerStyles,
                    backgroundColor: shadeBackgroundColor,
                    border: `2px solid ${borderColor}`,
                },
            }}
            dataKey={(item) => item.Id}
            data={{
                items: results,
                hasMore: hasNext ?? false,
                onLoadMore: loadNext,
                isLoading,
            }}
            filterable={{
                placeholder: 'Search units',
                filterText: filter.nameSearch ?? '',
                onChange: (nameSearch) =>
                    setFilter((existing) => ({ ...existing, nameSearch })),
            }}
            value={value}
            renderItem={({ item }) => item.Name}
            renderLabel={() => value?.Name ?? 'Select a unit'}
            onChange={onChange}
            isDisabled={disabled}
        />
    );
}
